module.exports = __webpack_public_path__ + "static/rg-05-6dbc3380a9a6d0522a10f66c679b1901.jpg";